const imagesPath = name => {
  return `https://cdn-instacarro-sandbox.s3.us-east-1.amazonaws.com/images/servicos-adicionais/${name}.png`;
};

export const servicesEnum = [
  {
    key: '01',
    title: 'Laudo de Venda',
    icon: imagesPath('laudo-de-venda'),
    value: 130,
    showCard: true,
    status: 'offer',
    link: null,
    reportType: 'new-cautelar',
  },
  {
    key: '02',
    title: 'Garantia',
    icon: imagesPath('garantia'),
    value: 299,
    valueText: 'à partir de',
    showCard: true,
    status: 'offer',
    link: null,
    hasOptions: true,
    reportType: null,
  },
  {
    key: '03',
    title: 'Cautelar',
    icon: imagesPath('cautelar'),
    value: 90,
    showCard: true,
    status: 'offer',
    link: null,
    reportType: 'cautelar',
  },
  {
    key: '04',
    title: 'Cautelar Visão Total',
    icon: imagesPath('visao-total'),
    value: 90,
    showCard: true,
    status: 'offer',
    link: null,
    reportType: 'laudo-total',
  },
  {
    key: '05',
    title: 'Frete RJ > SP',
    icon: imagesPath('frete'),
    value: 900,
    showCard: false,
    status: 'offer',
    link: null,
    reportType: null, // Frete não tem relatório
  },
];

/**
 * Função para atualizar o status dos serviços baseado no docStatus
 * @param {Array} services - Array de serviços
 * @param {Object} docStatus - Status dos relatórios vindo da API
 * @returns {Array} - Array de serviços com status atualizado
 */
export const updateServicesStatus = (services, docStatus, warrantyServiceEnabled = true) => {
  if (!docStatus) return services;

  return services.map(service => {
    // Tratamento especial para garantia (key '02') - só se a feature flag estiver habilitada
    if (service.key === '02') {
      const warrantyStatus = docStatus.warranty;

      return {
        ...service,
        title:
          warrantyStatus.databaseRecord?.document?.warrantyData?.selectedWarrantyOption?.title ||
          service.title,
        value:
          warrantyStatus.databaseRecord?.document?.warrantyData?.selectedWarrantyOption?.price ||
          service.value,
        status: warrantyStatus.databaseRecord?.found ? 'ready' : 'offer',
        link: warrantyStatus.databaseRecord?.document?.url || service.link,
        reportInfo: {
          message: warrantyStatus.message,
          databaseRecord: warrantyStatus.databaseRecord,
        },
        // Marcar como garantia para tratamento especial na mensagem
        isWarranty: true,
      };
    }

    // Se o serviço não tem reportType, mantém o status original
    if (!service.reportType) {
      return service;
    }

    const reportStatus = docStatus[service.reportType];
    if (!reportStatus) {
      return service;
    }

    // Se o serviço já está em 'waiting' (solicitado pelo usuário), só atualiza se o status for 'ready'
    if (service.status === 'waiting' && reportStatus.status !== 'ready') {
      return service;
    }

    // Mapeia o status do relatório para o status do serviço
    let newStatus = 'offer';
    let newLink = service.link;

    switch (reportStatus.status) {
      case 'ready':
        newStatus = 'ready';
        newLink = reportStatus.databaseRecord?.document?.url || service.link || reportStatus?.url;
        break;
      case 'waiting':
        newStatus = 'waiting';
        break;
      case 'processing':
        newStatus = 'waiting';
        break;
      case 'not-found':
        newStatus = 'offer';
        break;
      case 'error':
        newStatus = 'offer';
        break;
      case 'expired':
        newStatus = 'expired';
        newLink = null; // Não permite download de laudo expirado
        break;
      default:
        newStatus = 'offer';
    }

    const updatedService = {
      ...service,
      status: newStatus,
      link: newLink,
      reportInfo: {
        message: reportStatus.message,
        databaseRecord: reportStatus.databaseRecord,
      },
    };

    return updatedService;
  });
};

export const warrantyOptions = [
  {
    key: 'garantia-legal',
    title: 'Garantia Legal',
    price: 499,
    coverages: [
      {
        type: 'Motor/Câmbio',
        value: 6500,
        period: '90 dias após venda PF',
      },
    ],
  },
  {
    key: 'combo-loja-1ano',
    title: 'Combo Loja + 1 ano',
    price: 999,
    coverages: [
      {
        type: 'Motor/Câmbio',
        value: 20500,
        period: '30 dias após retirada',
      },
      {
        type: 'Motor/Câmbio',
        value: 10000,
        period: '12 meses após venda PF',
      },
    ],
  },
  {
    key: 'combo-loja-legal',
    title: 'Combo Loja + Legal',
    price: 699,
    coverages: [
      {
        type: 'Motor/Câmbio',
        value: 6500,
        period: '30 dias após retirada',
      },
      {
        type: 'Motor/Câmbio',
        value: 10000,
        period: '120 dias após retirada',
      },
    ],
  },
  {
    key: 'garantia-loja',
    title: 'Garantia Loja',
    price: 299,
    coverages: [
      {
        type: 'Motor/Câmbio',
        value: 6500,
        period: '30 dias após retirada',
      },
    ],
  },
  {
    key: 'garantia-1ano',
    title: 'Garantia 1 ano',
    price: 799,
    coverages: [
      {
        type: 'Motor/Câmbio',
        value: 10000,
        period: '12 meses após venda PF',
      },
    ],
  },
];
